import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { walletsByIdAtom } from '@root/entities/wallet/atoms'
import { WalletDepositDrawer } from '@root/features/wallet/deposit/ui/mobile'

import { useWalletTab } from './use-wallet-search-params'
import { WalletActions } from './wallet-actions'
import { WalletAssets } from './wallet-assets/wallet-assets'
import { WalletScreenHeader } from './wallet-header'
import { WalletScreenTabs } from './wallet-screen-tabs'
import { WalletSummary } from './wallet-summary'
import { WalletTransactions } from './wallet-transactions'

import type { WalletId } from '@root/entities/wallet/model'

type WalletScreenProps = {}

export const WalletScreen: React.FC<WalletScreenProps> = () => {
  const [depositOpened, setDepositOpened] = useState(false)
  const [tab] = useWalletTab()
  const { walletId } = useParams<{ walletId: WalletId }>()
  const [wallet] = useAtom(
    (ctx) => {
      if (!walletId) {
        return undefined
      }

      const walletsById = ctx.spy(walletsByIdAtom)

      return walletsById.get(walletId)
    },
    [walletId],
  )

  if (!wallet) {
    return undefined
  }

  const renderBody = () => {
    return match(tab)
      .with('assets', () => <WalletAssets wallet={wallet} />)
      .with('transactions', () => <WalletTransactions wallet={wallet} />)
      .exhaustive()
  }

  return (
    <Root>
      <WalletScreenHeader wallet={wallet} />
      <WalletBoard>
        <WalletBoardTop>
          <WalletSummary wallet={wallet} />
        </WalletBoardTop>
        <WalletActions wallet={wallet} />
      </WalletBoard>
      <WalletScreenTabs />
      {renderBody()}
      <WalletDepositDrawer
        open={depositOpened}
        onOpenChange={setDepositOpened}
        wallet={wallet}
      />
    </Root>
  )
}

const WalletBoard = styled.div`
  padding: 4px;
  background: var(--appearanceA-7);
  border-radius: 12px;
  display: grid;
  gap: 16px;
  margin-bottom: 10px;
  margin-inline: 12px;
`
const WalletBoardTop = styled.div`
  padding: 10px 12px 0;
`

const Root = styled.div`
  height: 100%;
  background: var(--background-1);

  display: grid;
  grid-template-rows: auto auto auto minmax(0, 1fr);
`
